const initialState = {
  metall_rama: false
}

const metallRama = (state = initialState, action) => {
  switch (action.type) {
    case "METALLRAMA_LAYER":
      return { ...state, metall_rama: action.val }
    // if (Object.keys(state).length > Object.keys(action.val).length) {
    //   const val = {}
    //   const preparedData = _.filter(action.val, (d) => {
    //     return _.some(state, (s) => s.id !== d.id)
    //   })
    //   preparedData.forEach((d) => {
    //     val[d.name] = { ...d, [d.name]: false, id: d.id }
    //   })
    //   return { ...val }
    // } else {
    //   return { ...action.val }
    // }
    default:
      return state
  }
}

export default metallRama
